var map = {
	"./Interface-Check.svg": 80,
	"./icon-adrenalin.svg": 1950,
	"./icon-check.svg": 4491,
	"./icon-druzina-otroci-da.svg": 880,
	"./icon-druzina-otroci-ne.svg": 8916,
	"./icon-info.svg": 7758,
	"./icon-invalidi-gibalno-ovirani-ne.svg": 2620,
	"./icon-invalidi-gibalno-ovirani.svg": 1447,
	"./icon-invalidi-ne.svg": 1367,
	"./icon-invalidi-vozicki.svg": 8035,
	"./icon-lahka.svg": 7160,
	"./icon-na-prostem.svg": 6022,
	"./icon-otroski-vozicek-da.svg": 6242,
	"./icon-otroski-vozicek-ne.svg": 3411,
	"./icon-pes.svg": 5986,
	"./icon-pod-streho.svg": 2938,
	"./icon-restavracija.svg": 8123,
	"./icon-romanticna.svg": 8565,
	"./icon-romantika.svg": 17,
	"./icon-srednje.svg": 2390,
	"./icon-za-zaljubljence-da.svg": 1797,
	"./icon-za-zaljubljence-ne.svg": 8661,
	"./icon-zahtevna.svg": 8127,
	"./q12a1.svg": 859,
	"./q12a2.svg": 6795,
	"./q12a3.svg": 8007,
	"./q12a4.svg": 7835,
	"./q2a1.svg": 6794,
	"./q2a2.svg": 5195,
	"./q2a3.svg": 4183,
	"./q2a4.svg": 3827,
	"./q2a5.svg": 1087,
	"./q5a1.jpg": 8044,
	"./q5a2.jpg": 850,
	"./q6a1.svg": 2561,
	"./q6a2.svg": 1099,
	"./q6a3.svg": 9043,
	"./q6a4.svg": 1826,
	"./q7a1.svg": 9029,
	"./q7a2.svg": 7327,
	"./q7a3.svg": 9740,
	"./q7a4.svg": 8028,
	"./q7a5.svg": 7443,
	"./q8a1.svg": 3717,
	"./q8a2.svg": 3944,
	"./q8a3.svg": 7871,
	"./q8a4.svg": 7711,
	"./q8a5.svg": 4291,
	"./q8a6.svg": 6044,
	"./q8a7.svg": 3654,
	"./q8a8.svg": 4896,
	"./q8a9.svg": 6421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4441;